import { useState } from "react"

// images
import snoozeImage from "@/assets/img/icons/snooze.svg"

// libraries
import { Menu } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query"

// helpers
import Api from "@/_helpers/Api"

export default function SnoozeUpcomingTodoButton({ id }) {
  const queryClient = useQueryClient()

  const [openMenu, setOpenMenu] = useState(null)

  function handleCloseMenu() {
    setOpenMenu(null)
  }

  function handleOpenMenu(e) {
    setOpenMenu(e.currentTarget)
  }

  function handleSelectSnoozeOption(option) {
    Api.post(`todos/${id}/postpone`, { interval: option }).then((res) => {
      queryClient.invalidateQueries({ queryKey: ["todos/new"] })
      queryClient.invalidateQueries({ queryKey: ["todos/all"] })
    })

    handleCloseMenu()
  }

  return (
    <>
      <button className="button-default button-small" onClick={handleOpenMenu}>
        <img src={snoozeImage} alt="snooze" />
        Отложи
      </button>

      <Menu
        anchorEl={openMenu}
        keepMounted
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
      >
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("1_day")}
        >
          1 ден
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("2_days")}
        >
          2 дни
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("3_days")}
        >
          3 дни
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("1_week")}
        >
          1 седмица
        </div>
      </Menu>
    </>
  )
}
